/**
 * Entry point.
 *
 * The first import is load-bearing and must stay first: it installs the CSP
 * style-nonce bridge before any module that creates a `<style>` is evaluated.
 * See `install-style-nonce.ts` for why it is an import rather than a call.
 */
import "./install-style-nonce";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";

import "@fontsource-variable/manrope";
import "./app.css";
import "./rainbowkit-theme.css";

import { App } from "./App";

const container = document.getElementById("root");
if (!container) {
  throw new Error("index.html has no #root element");
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
